import React, { useState, useEffect } from 'react';
import { Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';
import { db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';

const styles = StyleSheet.create({
    page: { padding: 30, fontFamily: 'Helvetica', fontSize: 11, color: '#333' },
    header: { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-start', borderBottom: '2px solid #2C3E50', paddingBottom: 10, marginBottom: 20 },
    headerInfo: { flex: 2 },
    headerTitle: { fontSize: 24, color: '#2C3E50', fontWeight: 'bold' },
    logo: { width: 60, height: 60, objectFit: 'contain' },
    companyDetails: { textAlign: 'right', fontSize: 10, color: '#7F8C8D' },
    section: { flexDirection: 'row', justifyContent: 'space-between', marginBottom: 20 },
    sectionColumn: { flex: 1 },
    sectionLabel: { fontWeight: 'bold', marginBottom: 5, color: '#18BC9C' },
    table: { display: 'table', width: 'auto', borderStyle: 'solid', borderWidth: 1, borderColor: '#eee', marginBottom: 20 },
    tableRow: { flexDirection: 'row', borderBottomWidth: 1, borderBottomColor: '#eee' },
    tableHeader: { backgroundColor: '#f2f2f2', borderBottomWidth: 2, borderBottomColor: '#ccc' },
    tableColHeader: { width: '40%', padding: 5, fontWeight: 'bold' },
    tableColQty: { width: '20%', padding: 5, fontWeight: 'bold', textAlign: 'right' },
    tableColPrice: { width: '20%', padding: 5, fontWeight: 'bold', textAlign: 'right' },
    tableColTotal: { width: '20%', padding: 5, fontWeight: 'bold', textAlign: 'right' },
    tableCell: { padding: 5 },
    tableCellQty: { textAlign: 'right' },
    tableCellPrice: { textAlign: 'right' },
    tableCellTotal: { textAlign: 'right' },
    totals: { flexDirection: 'row', justifyContent: 'flex-end', marginTop: 10 },
    totalsLabel: { width: '80%', textAlign: 'right', fontWeight: 'bold', padding: 5 },
    totalsValue: { width: '20%', textAlign: 'right', padding: 5, borderBottom: '1px solid #333' },
    footer: { position: 'absolute', bottom: 30, left: 30, right: 30, textAlign: 'center', color: 'grey', fontSize: 10 },
});

const OrdenCompraPDF = ({ orden }) => {
    const [logoUrl, setLogoUrl] = useState('');

    useEffect(() => {
        const fetchLogo = async () => {
            const configDocRef = doc(db, 'configuracion', 'empresa');
            const docSnap = await getDoc(configDocRef);
            if (docSnap.exists() && docSnap.data().logoBase64) {
                setLogoUrl(docSnap.data().logoBase64);
            }
        };
        fetchLogo();
    }, []);

    const formatDate = (dateValue) => {
        if (!dateValue) return 'N/A';
        const date = dateValue.toDate ? dateValue.toDate() : new Date(dateValue);
        return date.toLocaleDateString('es-ES');
    };

    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <View style={styles.header}>
                    <View style={styles.headerInfo}>
                        <Text style={styles.headerTitle}>Orden de Compra</Text>
                        <Text>ID de Orden: {orden.id.substring(0, 8)}</Text>
                        <Text>Fecha: {formatDate(orden.fecha)}</Text>
                    </View>
                    {logoUrl && <Image style={styles.logo} src={logoUrl} />}
                </View>

                <View style={styles.section}>
                    <View style={styles.sectionColumn}>
                        <Text style={styles.sectionLabel}>Proveedor</Text>
                        <Text>{orden.proveedor}</Text>
                    </View>
                    <View style={[styles.sectionColumn, { textAlign: 'right' }]}>
                        <Text style={styles.sectionLabel}>Enviar A</Text>
                        <Text>Hoppy Time</Text>
                        <Text>Tu Dirección, Ciudad</Text>
                        <Text>Tu CIF/NIF</Text>
                    </View>
                </View>

                <View style={styles.table}>
                    <View style={[styles.tableRow, styles.tableHeader]}>
                        <Text style={styles.tableColHeader}>Descripción</Text>
                        <Text style={styles.tableColQty}>Cantidad</Text>
                        <Text style={styles.tableColPrice}>Precio Unit.</Text>
                        <Text style={styles.tableColTotal}>Subtotal</Text>
                    </View>
                    {orden.items?.map((item, index) => (
                        <View style={styles.tableRow} key={index}>
                            <Text style={styles.tableColHeader}>{item.producto}</Text>
                            <Text style={[styles.tableCell, styles.tableCellQty]}>{item.cantidad}</Text>
                            <Text style={[styles.tableCell, styles.tableCellPrice]}>{item.costoUnitario.toLocaleString('es-ES', {minimumFractionDigits: 2})} €</Text>
                            <Text style={[styles.tableCell, styles.tableCellTotal]}>{item.costoTotalItem.toLocaleString('es-ES', {minimumFractionDigits: 2})} €</Text>
                        </View>
                    ))}
                </View>

                <View style={styles.totals}>
                    <Text style={styles.totalsLabel}>TOTAL</Text>
                    <Text style={styles.totalsValue}>{orden.costoTotal.toLocaleString('es-ES', {minimumFractionDigits: 2})} €</Text>
                </View>

                <Text style={styles.footer}>Documento generado por Hoppy Time App</Text>
            </Page>
        </Document>
    );
};

export default OrdenCompraPDF;